import axios from "axios";

/**
 * Analytics event enum — MUST match backend routes_dashboard.py regex.
 * If you add a new event type here, add it to the backend regex too.
 */
export const TRACK_EVENTS = Object.freeze({
  LANDING_VISIT: "landing_visit",
  FORM_STARTED: "form_started",
  PAYMENT_INITIATED: "payment_initiated",
});
const ALLOWED = new Set(Object.values(TRACK_EVENTS));

const KEY = "bni-session-id";
export function sessionId() {
  let s = localStorage.getItem(KEY);
  if (!s) {
    s = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, "");
    localStorage.setItem(KEY, s);
  }
  return s;
}

const sent = new Set();
export function track(event_type, event_slug) {
  if (!ALLOWED.has(event_type)) {
    // Fail loudly in dev; silent no-op in prod so a typo never breaks the page.
    if (process.env.NODE_ENV !== "production") {
      console.warn(`[track] unknown event_type "${event_type}" — allowed: ${[...ALLOWED].join(", ")}`);
    }
    return;
  }
  const k = `${event_slug}:${event_type}`;
  if (sent.has(k)) return;
  sent.add(k);
  axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track`,
    { event_type, session_id: sessionId(), event_slug }).catch(() => {});
}
